// extracted by mini-css-extract-plugin
export default {"work":"CardProject_work__ZzyK4","work_avatar":"CardProject_work_avatar__65twj","short_description":"CardProject_short_description__7wuG4"};